/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Intro_H2Inputs */

const es_gift_intro_h2 = /** @type {(inputs: Gift_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un regalo que se vive, no se guarda en un cajón.`)
};

const gl_gift_intro_h2 = /** @type {(inputs: Gift_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un agasallo que se vive, non se garda nun caixón.`)
};

const en_gift_intro_h2 = /** @type {(inputs: Gift_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gift to live, not to leave in a drawer.`)
};

/**
* | output |
* | --- |
* | "A gift to live, not to leave in a drawer." |
*
* @param {Gift_Intro_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_intro_h2 = /** @type {((inputs?: Gift_Intro_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Intro_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_intro_h2(inputs)
	if (locale === "en") return en_gift_intro_h2(inputs)
	return es_gift_intro_h2(inputs)
});